export const getReturnReasonsPayload = reasons => {
  return reasons.map((reason, index) => {
    return {
      id: reason.id,
      enabled: reason.is_enabled,
      position: index,
    }
  })
}
